import {createRouter, createWebHistory} from 'vue-router'

/* Layout */
import Layout from '@/layout/index'
import userRouter from './modules/pc/user_center'
import chatRouter from './modules/pc/chat'
import agentRouter from './modules/pc/agent'
import knowledgeRouter from './modules/pc/knowledge'
import attachmentRouter from './modules/pc/attachment'
import orgAdminRouter from './modules/org_admin/admin'

// import mobileRouter from './modules/mobile/mobile'

/**
 * 不需要授权
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'LoginBridge',
    redirect: to => ({
      path: '/home',
      query: {
        ...to.query,
        login: '1'
      }
    }),
    hidden: true
  },
  {
    path: '/mobile/mobile-login',
    name: 'MobileLogin',
    component: () => import('@/views/login/login.vue'),
    meta: {public: true},
    hidden: true
  },
  {
    path: '/mobile/guide',
    name: 'MobilePcAccessGuide',
    component: () => import('@/views/mobile/PcAccessGuide.vue'),
    meta: {title: 'views.login.mobile_pc_guide_title', public: true},
    hidden: true
  },
  {
    path: '/google_auth/:google_code?',
    component: () => import('@/views/login/components/google_auth.vue'),
    meta: {public: true},
    hidden: true
  },
  {
    name: 'forget',
    path: '/forget',

    meta: {title: '忘记密码', public: true},
    component: () => import('@/views/login/forget_the_password.vue')
  },
  {
    path: '/join-team/:invite_code',
    name: 'JoinTeam',
    component: () => import('@/views/user_center/join_team'),
    meta: {public: true},
    hidden: true
  },
  {
    path: '/invitation/:code',
    name: 'InviteLanding',
    component: () => import('@/views/invitation/invite_landing.vue'),
    meta: {public: true},
    hidden: true
  },
  {
    path: '/legal/terms',
    name: 'LegalTerms',
    component: () => import('@/views/legal/index.vue'),
    props: {documentType: 'terms'},
    meta: {title: 'views.legal.terms_title', public: true},
    hidden: true
  },
  {
    path: '/legal/privacy',
    name: 'LegalPrivacy',
    component: () => import('@/views/legal/index.vue'),
    props: {documentType: 'privacy'},
    meta: {title: 'views.legal.privacy_title', public: true},
    hidden: true
  },
  {

    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'home',
    meta: {title: 'router.home'},
    children: [
      {
        name: 'Home',
        path: 'home',
        meta: {title: 'router.home', public: true},
        component: () => import('@/views/home.vue')
      },
      {
        name: 'ImageGeneration',
        path: 'image-generation',
        meta: {title: 'router.image-generation', public: true},
        component: () => import('@/views/image-generation/index.vue'),
        children: [
          {
            name: 'ImageGenerationCollection',
            path: 'collection/:categoryKey',
            meta: {title: 'router.image-generation', public: true},
            component: () => import('@/views/image-generation/collection.vue')
          },
          {
            name: 'ImageGenerationSearch',
            path: 'search',
            meta: {title: 'router.image-generation', public: true},
            component: () => import('@/views/image-generation/search.vue')
          }
        ]
      },
      {
        name: 'VideoGeneration',
        path: 'video-generation',
        meta: {title: 'router.video-generation', public: true},
        component: () => import('@/views/video-generation/index.vue')
      },
      {
        name: 'WebGeneration',
        path: 'web-generation',
        meta: {title: 'router.web-generation', public: true},
        component: () => import('@/views/home.vue')
      },
      {
        name: 'Dashboard',
        path: 'agents',
        meta: {title: 'router.dashboard'},
        component: () => import('@/views/dashboard.vue')
      },
      {
        name: 'AgentSetting',
        path: 'agent-setting',
        meta: {title: 'router.agent-setting'},
        component: () => import('@/views/agent/agent_setting.vue')
      },
      {
        name: 'user-invitation',
        path: 'invite',
        meta: {title: 'router.invitation'},
        component: () => import('@/views/invitation/invitation.vue')
      },
      {
        name: 'knowledge',
        path: 'knowledge',
        meta: {title: 'router.knowledge'},
        component: () => import('@/views/knowledge/wiki.vue')
      },
      {
        name: '404',
        path: '404',
        meta: {title: '404-error', public: true},
        component: () => import('@/views/404'),
        hidden: true
      },
    ]
  },
  {
    path: '/chat-share/:share_code',
    name: 'ChatShare',
    component: () => import('@/views/chat/chat_share.vue'),
    meta: {public: true},
    hidden: true
  },
  {
    path: '/web_preview/:ver_uuid',
    name: 'WebPreview',
    component: () => import('@/views/web_preview.vue'),
    meta: {public: true},
    hidden: true
  },
  {
    path: '/pdf-print/:doc_uniq_code',
    name: 'PdfPrint',
    component: () => import('@/views/knowledge/pdf_print.vue'),
    meta: {public: true},
    hidden: true
  },
  userRouter,
  chatRouter,
  agentRouter,
  orgAdminRouter,
  knowledgeRouter,
  attachmentRouter
]

/**
 * 需要授权
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})

export default router
